import { Component, OnInit } from '@angular/core';
import { DataMessageTypeModel, DATA_MESSAGE_TYPE_OPTIONS } from '../../model/data-message.model';
import { CreateUpdateComponent } from '../create-update.component';

@Component({
	selector: 'cv-invision-create-update-data-message-type',
	templateUrl: './create-update-data-message-type.component.html',
	styleUrls: ['./create-update-data-message-type.component.scss']
})

export class CreateUpdateDataMessageTypeComponent extends CreateUpdateComponent implements OnInit {
	config: any = new DataMessageTypeModel();
	originalConfig: any = new DataMessageTypeModel();
	dataMessageTypeOptions: Array<any> = DATA_MESSAGE_TYPE_OPTIONS;

	ngOnInit(): void {
		super.ngOnInit();

		if (!this.data.isEditing) {
			this.config = {
				nexsysAttribute: '',
				appScopeType: '',
				acuityType: ''
			};
		}
	}

	/**
	 * Is form valid?
	 */
	setIsFormValid(): boolean {
		return this.config.nexsysAttribute.trim().length > 0 && this.isDirty();
	}

	/**
	 * Select AppScope Message Type
	 * @param $event
	 */
	onAppScopeTypeSelected($event: any): void {
		if ($event) {
			this.config.appScopeType = $event;
		}
	}

	/**
	 * Select Acuity Message Type
	 * @param $event
	 */
	onAcuityTypeSelected($event: any): void {
		if ($event) {
			this.config.acuityType = $event;
		}
	}

	/**
	 * Select CMP Acuity Message Type
	 * @param $event
	 */
	onCmpAcuityTypeSelected($event: any): void {
		if ($event) {
			this.config.cmpAcuityType = $event;
		}
	}
}
